import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export type multiSelectComparatorOutput = {
  value: number;
  comparator: string;
};

@Component({
  selector: 'multi-select-number-comparator',
  styleUrls: ['./multi-select-number-comparator.component.scss'],
  templateUrl: './multi-select-number-comparator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MultiSelectNumberComparatorComponent),
    },
  ],
})
export class MultiSelectNumberComparatorComponent {
  options = ['Greater than', 'Less than', 'Equal to'].map(x => ({
    id: x,
    title: x,
  }));

  @Input()
  selectedOption = 'Greater than';
  @Input()
  value = 0;
  @Input()
  label: string;
  @Input()
  disabled: boolean;
  @Input()
  autoFocus: boolean;
  @Input()
  warning: string;
  @Input()
  error: string;

  @Output()
  readonly optionChange = new EventEmitter<string>();
  @Output()
  readonly valueChange = new EventEmitter<number>();
  @Output()
  readonly onChange = new EventEmitter<multiSelectComparatorOutput>();

  onOptionChange(event: string) {
    this.selectedOption = event;
    this.optionChange.emit(this.selectedOption);
    this.onChange.emit({
      value: this.value,
      comparator: this.selectedOption,
    });
  }

  onValueChange(event: number) {
    this.value = event;
    this.valueChange.emit(this.value);
    this.onChange.emit({
      value: this.value,
      comparator: this.selectedOption,
    });
  }
}
